export { TablaModule } from './tabla.module';
export { Tabla } from './tabla.component';
export { collapsibleTabla } from './collapsible.animation';
export * from './interfaces';
